<template>
    <v-container v-if="loadSkeleton">
        <SkeletonLoader ruta="turnos" tipo="table-heading, card, image, table-tfoot"></SkeletonLoader>
    </v-container>
    <v-container v-else>
        <v-card flat>
            <v-card-title class="font-weight-bold text-h5">
                <v-icon color="primary" class="mr-3" size="34">mdi-list-box-outline</v-icon>
                {{ titulo }}
            </v-card-title>
            <v-card class="rounded-0" outlined>
                <v-card-title class="d-flex flex-row font-weight-bold primary--text text-h5"
                    style="word-break: keep-all;">
                    {{ subtitulo }}
                </v-card-title>
                <v-card-text v-if="!esJubilado">
                    <ValidationObserver ref="observer" v-slot="{ invalid }">
                        <v-form @submit.prevent="onSubmit">
                            <v-row class="d-flex flex-row mt-5">
                                <v-col cols="12" md="12">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-autocomplete dense v-model="selectedItem" deletable-chips chips
                                            label="Tipo de aportes" :error-messages="v.errors[0]"
                                            :items="selectorDetalleAp" clearable hide-selected item-value="tipapo"
                                            :item-text="item => `${item.codapo} - ${(item.destipapo)}`"
                                            color="primary"></v-autocomplete>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12" class="d-flex justify-end">
                                    <v-btn type="onSubmit" elevation="0" class="pa-5" :disabled="invalid"
                                        color="primary">
                                        <v-icon class="mr-2">mdi-download</v-icon>
                                        Descargar
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </ValidationObserver>
                </v-card-text>
                <v-card-text v-else>
                    <v-row class="d-flex flex-row mt-5">
                        <v-col cols="12" md="12">
                            <v-text-field value="PR - Préstamo" readonly label="Préstamo"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="12" class="d-flex justify-end">
                            <v-btn @click="descargar" elevation="0" class="pa-5" color="primary">
                                <v-icon class="mr-2">mdi-download</v-icon>
                                Descargar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <!-- <v-card flat class="rounded-0">
                <v-card class="rounded-0" outlined>
                    <v-card-title class="d-flex flex-row font-weight-bold primary--text text-h5">
                        Consultá el detalle de tus aportes
                    </v-card-title>
                    <v-card-text>
                        <ValidationObserver ref="obs" v-slot="{ invalid }">
                            <v-form name="form" @submit.prevent="descargarDetalle">
                                <v-row class="d-flex flex-row">
                                    <v-col cols="12" md="12">
                                        <v-text-field class="mb-3 custom-label" append-icon="mdi-account"
                                            :value="user.nroafi" outlineed type="number" readonly autofocus="true"
                                            label="Nro. Afiliado" label-color="primary"></v-text-field>
                                        <ValidationProvider rules="required|max:10" v-slot="v">
                                            <v-select v-model="selectedAporte" :items="array"></v-select>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" md="12" class="d-flex justify-end">
                                        <v-btn type="descargar" elevation="0" class="pa-5" :disabled="invalid"
                                            color="primary">
                                            <v-icon class="mr-2">mdi-download</v-icon>
                                            Descargar
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text>
                </v-card>
            </v-card> -->
        </v-card>
    </v-container>
</template>

<script>
import SkeletonLoader from '@/components/alerts/SkeletonLoader.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapGetters, mapActions } from 'vuex'


export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        SkeletonLoader
    },
    data() {
        return {
            selectedItem: [],
        }
    },
    name: 'DetalleDeAportes',
    mounted() {

    },
    computed: {
        ...mapGetters('boletas', ['tpapo', 'mescuota', 'boletasDisponibles', 'porTipApo', 'conceptosDeuda', 'resumenAportes', 'selectorDetalleAp']),
        ...mapGetters('auth', ['nroafi', 'loadSkeleton', 'esJubilado', 'token']),

        titulo() {
            return this.esJubilado ? 'Detalle de préstamos' : 'Detalle de aportes'
        },
        subtitulo() {
            return this.esJubilado ? 'Descargá el detalle de tus préstamos' : 'Descargá el detalle de tus aportes'
        }
    },
    methods: {
        ...mapActions('boletas', ['imprimirPdfDetalle', 'getResumenAportes']),
        onSubmit() {
            this.$refs.observer.validate().then(result => {
                if (result) {
                    const data = {
                        url: process.env.VUE_APP_APORTES,
                        nroafi: this.nroafi,
                        tapid: this.selectedItem,
                        da: '',
                        token: this.token
                    }
                    this.imprimirPdfDetalle(data)
                } else {
                    this.showSnack({
                        message: 'Formulario inválido, no se puede enviar la petición',
                        type: '400'
                    })
                }
            });
        },
        descargar() {
            const data = {
                url: process.env.VUE_APP_APORTES,
                nroafi: this.nroafi,
                tapid: 4,
                da: '',
                token: this.token
            }
            console.log(data)
            this.imprimirPdfDetalle(data)
        }
    },
}
</script>